import React from 'react';
import { Box, Typography } from '@mui/material';
import { PANEL_SECTION_TITLE_SX, LOT_INFO_DETAIL_SURFACE_SX, LOT_INFO_SECTION_BORDER, LOT_INFO_SECTION_CONTENT_BG } from './formBlockUi';

export const LOT_DETAIL_TABLE_SX = {
  ...LOT_INFO_DETAIL_SURFACE_SX,
  border: 'none',
  borderRadius: 0,
  bgcolor: 'transparent',
};

const InfoMessage = ({ children }) => (
  <Box
    sx={{
      px: 1.25,
      py: 1,
      borderRadius: '8px',
      border: `1px solid ${LOT_INFO_SECTION_BORDER}`,
      bgcolor: LOT_INFO_SECTION_CONTENT_BG,
    }}
  >
    <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', lineHeight: 1.35 }}>
      {children}
    </Typography>
  </Box>
);

const LotDetailSectionShell = ({
  title,
  hideTitle = false,
  blocked = false,
  blockedMessage,
  children,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    {!hideTitle && (
      <Typography variant="caption" sx={PANEL_SECTION_TITLE_SX}>
        {title}
      </Typography>
    )}

    {blocked ? (
      <InfoMessage>{blockedMessage}</InfoMessage>
    ) : (
      children
    )}
  </Box>
);

export const LotDetailTable = ({ children }) => (
  <Box sx={LOT_DETAIL_TABLE_SX}>
    {children}
  </Box>
);

export const LotDetailTableRow = ({ children, hideDivider = false }) => (
  <Box sx={hideDivider ? undefined : { borderBottom: `1px solid ${LOT_INFO_SECTION_BORDER}` }}>
    {children}
  </Box>
);

export default LotDetailSectionShell;
